import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { getInitialLoadResourceEntries } from "./resourceTiming";
var MAX_RESOURCE_ENTRY_BUFFER_SIZE = 250;
export var ResourceTimingCollector = function ResourceTimingCollector() {
    "use strict";
    var _this = this;
    _class_call_check(this, ResourceTimingCollector);
    this.resourceTimings = [];
    this.observer = undefined;
    this.initialize = function() {
        var _getWindow;
        if (_this.observer) {
            return;
        }
        var PerformanceObserver = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.PerformanceObserver;
        if (PerformanceObserver) {
            _this.observer = new PerformanceObserver(function(entries) {
                var _this_resourceTimings;
                (_this_resourceTimings = _this.resourceTimings).push.apply(_this_resourceTimings, _to_consumable_array(entries.getEntries()));
                var bufferOversizeCount = _this.resourceTimings.length - MAX_RESOURCE_ENTRY_BUFFER_SIZE;
                if (bufferOversizeCount > 0) {
                    _this.resourceTimings.splice(0, bufferOversizeCount);
                }
            });
            _this.observer.observe({
                entryTypes: [
                    "resource"
                ]
            });
        }
    };
    this.getResourceEntries = function(timeOfLastRouteChange) {
        if (timeOfLastRouteChange === 0) {
            return getInitialLoadResourceEntries();
        } else if (_this.observer) {
            return _this.resourceTimings.filter(function(entry) {
                return entry.startTime >= timeOfLastRouteChange;
            });
        } else {
            // Use undefined to indicate that PerformanceObserver is not supported.
            return undefined;
        }
    };
};
ResourceTimingCollector.get = singletonGetter(ResourceTimingCollector);
